<template>
  <div class="user">
    <!--添加任务-->
    <div >
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="医生/患者名称">
          <el-input placeholder="请输入医生/患者名称" v-model="formInline.search"></el-input>
        </el-form-item>
        
        <!-- 新增：类型筛选 -->
        <el-form-item label="类型筛选">
          <el-select v-model="formInline.categories" placeholder="请选择类型" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="医生" :value="1"></el-option>
            <el-option label="患者" :value="2"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
           <el-button size="small" @click="batchExport">导出信息</el-button>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加医生/患者</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="hospital" label="医院"></el-table-column>
            <el-table-column prop="department" label="科室"></el-table-column>
            <el-table-column prop="phone" label="电话"></el-table-column>
            <el-table-column prop="wechat" label="微信"></el-table-column>
            <el-table-column prop="categories" label="身份">
              <template slot-scope="scope">
                {{ scope.row.categories === 1 ? '医生' : scope.row.categories === 2 ? '患者' : '未知' }}
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="showEntryInfo(scope.row)" type="text" size="small">查看记录</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :basis_id="basis_id" v-if="open_edit" @close="closeEdit"></Edit>

    <!-- 录入信息对话框 -->
    <el-dialog 
      :title="entryDialogTitle" 
      :visible.sync="entryDialogVisible" 
      width="70%"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      
      <el-table :data="currentEntryData" border style="width: 100%">
        <!-- 医生类型的显示列 -->
        <template v-if="currentCategories === 1">
          <el-table-column prop="visit_date" label="拜访日期" width="120"></el-table-column>
          <el-table-column prop="visit_content" label="拜访纪要" min-width="200"></el-table-column>
          <el-table-column prop="plan_date" label="后续拜访日期" width="120"></el-table-column>
          <el-table-column prop="create_time" label="记录时间" width="160"></el-table-column>
        </template>
        
        <!-- 患者类型的显示列 -->
        <template v-else-if="currentCategories === 2">
          <el-table-column prop="surgery_date" label="手术日期" width="120"></el-table-column>
          <el-table-column prop="condition" label="患者状况" min-width="150"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="150"></el-table-column>
          <el-table-column prop="record_time" label="记录时间" width="120"></el-table-column>
          <el-table-column prop="remove_date" label="取出时间" width="120"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
        </template>
      </el-table>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="entryDialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
      :close-on-click-modal="false" 
      :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  </div>
</template>

<script>
  import BasisApi from '@/api/basis.js';
  import Add from './part/add.vue';
  import qs from 'qs';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search: "",
          categories: "" // 新增：类型筛选条件
        },
        open_add: false,
        open_edit: false,
        basis_id: "",
        dialogVisible: false,
        
        // 新增的数据属性
        entryDialogVisible: false, // 录入信息对话框显示状态
        currentEntryData: [], // 当前选择的录入信息数据
        currentCategories: 0, // 当前选择的记录类型
        entryDialogTitle: "录入信息" // 对话框标题
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible() {
        this.dialogVisible = false;
      },
      setting(e) { // 医生/患者标题设置
        this.dialogVisible = true;
      },
      /*关闭添加*/
      closeAdd(e) {
        this.open_add = false;
        this.getTableList();
      },
      closeEdit(e) {
        this.open_edit = false;
        this.getTableList();
      },
      getData() {
        this.curPage = 1; // 重置到第一页
        this.getTableList();
      },
      /*重置搜索条件*/
      resetSearch() {
        this.formInline = {
          search: "",
          categories: ""
        };
        this.getData();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = {
          ...this.formInline, // 包含搜索条件和类型筛选
          page: self.curPage,
          list_rows: self.pageSize
        };
        
        self.loading = true;
        BasisApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
            console.error('获取数据失败:', error);
          });
      },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },
      /*添加任务*/
      addClick() {
        this.open_add = true;
      },
      /*编辑活动*/
      editClick(row) {
        this.basis_id = row.basis_id;
        this.open_edit = true;
      },
      batchExport(){
        console.log(111111111);
        
         let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/plus.basis.Index/exportInfo?' + qs.stringify(this.formInline);
      },
      /*显示录入信息*/
      showEntryInfo(row) {
        this.currentEntryData = row.entry || [];
        this.currentCategories = row.categories;
        
        // 设置对话框标题
        if (row.categories === 1) {
          this.entryDialogTitle = `医生【${row.name}】的拜访记录`;
        } else if (row.categories === 2) {
          this.entryDialogTitle = `患者【${row.name}】的治疗记录`;
        } else {
          this.entryDialogTitle = `【${row.name}】的记录信息`;
        }
        
        this.entryDialogVisible = true;
      },
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            BasisApi.del(
              {
                basis_id: row.basis_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('删除失败');
                }
              })
              .catch(error => {
                self.$message.error('删除失败');
              });
          })
          .catch(() => {
            // 取消删除
          });
      }
    }
  };
</script>

<style>
  .user {
    padding: 20px;
  }
  
  .common-seach-wrap {
    background: #fff;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .common-level-rail {
    margin-bottom: 20px;
  }
  
  .product-content {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  
  /* 调整表单布局，适应新增的筛选条件 */
  .demo-form-inline .el-form-item {
    margin-bottom: 0;
    margin-right: 15px;
  }
  
  .demo-form-inline .el-form-item:last-child {
    margin-right: 0;
  }
</style>


// WEBPACK FOOTER //
// src/views/plus/basis/index/index.vue